export class SoldTo {
   _id: string;
   name: string;
   tagNumber: string;
}